import type { StripeElementLocale } from '@stripe/stripe-js';

import type { Locale } from '@change-corgi/config/locales';

// Derived from the StripeElementLocale union (excluding 'auto')
const STRIPE_LOCALES = [
	'ar',
	'bg',
	'cs',
	'da',
	'de',
	'el',
	'en',
	'en-AU',
	'en-CA',
	'en-NZ',
	'en-GB',
	'es',
	'es-ES',
	'es-419',
	'et',
	'fi',
	'fil',
	'fr',
	'fr-CA',
	'fr-FR',
	'he',
	'hu',
	'hr',
	'id',
	'it',
	'it-IT',
	'ja',
	'ko',
	'lt',
	'lv',
	'ms',
	'mt',
	'nb',
	'nl',
	'no',
	'pl',
	'pt',
	'pt-BR',
	'ro',
	'ru',
	'sk',
	'sl',
	'sv',
	'th',
	'tr',
	'vi',
	'zh',
	'zh-HK',
	'zh-TW',
] as const satisfies readonly StripeElementLocale[];

function isStripeLocale(s: string): s is StripeElementLocale {
	return (STRIPE_LOCALES as readonly string[]).includes(s);
}

export function toStripeLocale(locale: Locale): StripeElementLocale {
	if (isStripeLocale(locale)) return locale;
	const languageCode = locale.split('-')[0];
	if (isStripeLocale(languageCode)) return languageCode;
	return 'auto';
}
